// Base component class that all Mix&Match components will extend
export class MixMatchComponent extends HTMLElement {
  unsubscribe: (() => void) | null = null;

  constructor() {
    super();
    this.unsubscribe = null;
  }

  connectedCallback(): void {
    if (window.mixMatchStore) {
      this.unsubscribe = window.mixMatchStore.subscribe((state) =>
        this.onStateChange(state)
      );
    }
  }

  disconnectedCallback(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }

  // Each component implements this method
  onStateChange({ action, previousState, state }: {
    action: string;
    previousState: any;
    state: any;
  }): void {
    // To be implemented by child classes
  }
}

